module.exports = __webpack_public_path__ + "img/video-27.b365ee40.png";